// Group GROUP 17. Conditionals and Mixed Forms
// Complete data from "Grammar 90 Groups (GPT5) 5 Examples Each.txt"

export const group17Data = {
  "id": "group_17",
  "title": {
    "tc": "條件與混合",
    "sc": "条件与混合",
    "en": "Conditionals and Mixed Forms"
  },
  "subtitle": {
    "tc": "Conditionals and Mixed Forms",
    "sc": "Conditionals and Mixed Forms",
    "en": "Conditionals and Mixed Forms"
  },
  "icon": "🔄",
  "difficulty": "advanced",
  "color": "from-pink-500 to-pink-600",
  "topics": [
    {
      "id": "mixed_conditionals",
      "title": {
        "tc": "混合條件",
        "sc": "混合条件",
        "en": "Mixed Conditionals"
      },
      "description": {
        "tc": "學習混合條件句的用法",
        "sc": "学习混合条件句的用法",
        "en": "Learn mixed conditional structures"
      },
      "icon": "🔄",
      "difficulty": "advanced",
      "examples": [
        {
          "id": "mixed_1",
          "sentence": "If I had left earlier, I would be home now.",
          "analysis": "If [I had left earlier], I (S) would be (V) home (C) now (M).",
          "translation": {
            "tc": "如果我早點離開，我現在就會在家了。",
            "sc": "如果我早点离开，我现在就会在家了。",
            "en": "If I had left earlier, I would be home now."
          }
        },
        {
          "id": "mixed_2",
          "sentence": "If she were more careful, she wouldn't have made that mistake.",
          "analysis": "If [she were more careful], she (S) would not have made (V) that mistake (O).",
          "translation": {
            "tc": "如果她更小心，她就不會犯那個錯誤了。",
            "sc": "如果她更小心，她就不会犯那个错误了。",
            "en": "If she were more careful, she wouldn't have made that mistake."
          }
        },
        {
          "id": "mixed_3",
          "sentence": "If he hadn't missed the bus, he would be on time.",
          "analysis": "If [he hadn't missed the bus], he (S) would be (V) on time (C).",
          "translation": {
            "tc": "如果他沒有錯過公車，他就會準時了。",
            "sc": "如果他没有错过公交车，他就会准时了。",
            "en": "If he hadn't missed the bus, he would be on time."
          }
        },
        {
          "id": "mixed_4",
          "sentence": "If I were you, I would have apologized.",
          "analysis": "If [I were you], I (S) would have apologized (V).",
          "translation": {
            "tc": "如果我是你，我就會道歉了。",
            "sc": "如果我是你，我就会道歉了。",
            "en": "If I were you, I would have apologized."
          }
        },
        {
          "id": "mixed_5",
          "sentence": "If it weren't raining, we would have gone out.",
          "analysis": "If [it weren't raining], we (S) would have gone out (V).",
          "translation": {
            "tc": "如果沒有下雨，我們就會出去了。",
            "sc": "如果没有下雨，我们就会出去了。",
            "en": "If it weren't raining, we would have gone out."
          }
        }
      ],
      "teachingNotes": {
        "tc": "要點：過去條件 + 現在結果 / 現在條件 + 過去結果的交叉組合。",
        "sc": "要点：过去条件 + 现在结果 / 现在条件 + 过去结果的交叉组合。",
        "en": "Key points: past condition + present result / present condition + past result cross combinations."
      }
    }
  ]
};
